import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hpsfir-card desktop" }

import {
  HpsfirProTable,
  HpsfirProTableColumn,
  HpsfirProTableData,
  HpsfirProTableFilter,
  HpsfirProTableGetDataFunction,
  useBaseAsync,
} from 'hpsfir-managebase-ui';
import { useApi } from '@/hooks/useApi';
import { ElMessage } from 'element-plus';
import { ref } from 'vue';
import { SEATSTATUSE, SeatSpe, DESKTOPTYPEE } from '@/api';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const columns = ref<HpsfirProTableColumn[]>([]);
const tableRef = ref<InstanceType<typeof HpsfirProTable>>();

const addInitValue = {
  sequence: 0,
};

const conditionsInitValue = {
};

// 桌位状态映射
const seatStatusMap: Record<string, string> = {
  [SEATSTATUSE.Idle]: '空闲',
  [SEATSTATUSE.Reserved]: '已预约',
  [SEATSTATUSE.Playing]: '游戏中',
};

// 桌面类型映射
const desktopTypeMap: Record<string, string> = {
  [DESKTOPTYPEE.Reservation]: '预约',
  [DESKTOPTYPEE.OrderDesk]: '点单桌',
};

// 桌面类型选项
const desktopTypeOptions = [
  { label: '预约', value: DESKTOPTYPEE.Reservation },
  { label: '点单桌', value: DESKTOPTYPEE.OrderDesk },
];


// 格式化桌位列表显示
const formatSeats = (seats: SeatSpe[]) => {
  if (!seats || seats.length === 0) {
    return '暂无桌位';
  }
  return seats.map((seat) => `${seat.seatNumber}号(${seatStatusMap[seat.status] || seat.status})`).join(', ');
};

// 创建列定义
const createColumns = () => [
  {
    name: 'sequence',
    label: '排序',
    type: 'number',
    isCondition: false,
    rule: [{ required: false, message: '请输入排序' }],
    width: 80,
  },
  {
    name: 'name',
    label: '名称',
    type: 'string',
    isCondition: true,
    rule: [{ required: true, message: '请输入名称' }],
    width: 150,
  },
  {
    name: 'basePoints',
    label: '基础积分',
    type: 'string',
    isCondition: false,
    rule: [
      { required: true, message: '请输入基础积分' },
      { pattern: /^\d+\/\d+$/u, message: '格式须为"整数/整数"，如：100/200' },
    ],
    width: 120,
  },
  {
    name: 'desktopType',
    label: '桌面类型',
    type: 'multiselect',
    isCondition: false,
    rule: [{ required: false, message: '请选择桌面类型' }],
    width: 150,
    options: desktopTypeOptions,
  },
  {
    name: 'createTime',
    label: '创建时间',
    type: 'string',
    hideEdit: true,
    hideCreate: true,
    width: 160,
  },
] as HpsfirProTableColumn[];


// 初始化
const init = useBaseAsync(() => {
  columns.value = createColumns();
});

const operates: any[] = [];

const loading = ref(false);

const getData = useBaseAsync<HpsfirProTableGetDataFunction>(async(filter: HpsfirProTableFilter) => {
  try {
    loading.value = true;
    const res = await useApi().desktopApi.pageDesktopdesktop({
      conditions: Object.entries(filter.conditions).reduce((conditions, [key, val]) => {
        if (val === null || val === undefined || val === '') {
          return conditions;
        }

        conditions[key] = val;

        return conditions;
      }, {} as any),
      pageQuery: {
        page: filter.paginations.page - 1,
        pageSize: filter.paginations.pageSize,
      },
    });

    const tableData: HpsfirProTableData = {
      total: res.data.data?.total || 0,
      data: res.data.data?.data || [],
    };
    return tableData;
  } finally {
    loading.value = false;
  }
});

const formatDeleteInfo = (row: any) => `您确定要删除"${row.name || '未命名'}"吗？此操作不可恢复，请谨慎操作。`;

const addFun = useBaseAsync(async(data: any) => {
  await useApi().desktopApi.addDesktopdesktop({
    desktopAdminVo: {
      ...data,
    },
  });
  ElMessage.success('添加成功');
});

const updateFun = useBaseAsync(async(data: any) => {
  await useApi().desktopApi.updateDesktopdesktop({
    desktopAdminVo: {
      ...data,
    },
  });
  ElMessage.success('修改成功');
});

const deleteFun = useBaseAsync(async(data: any) => {
  await useApi().desktopApi.delDesktopdesktop(data.id);
  ElMessage.success('删除成功');
});


Promise.all([init()]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(HpsfirProTable), {
      ref_key: "tableRef",
      ref: tableRef,
      paginations: { pageSize: 10 },
      "page-layout": "total, sizes, prev, pager, next",
      columns: columns.value,
      "get-data": _unref(getData),
      "on-add": _unref(addFun),
      "on-delete": _unref(deleteFun),
      "on-edit": _unref(updateFun),
      loading: loading.value,
      "is-dangder-delete": true,
      "format-dangder-delete-info": formatDeleteInfo,
      "row-key": "id",
      operates: operates,
      "add-init-values": addInitValue,
      "codition-init-values": conditionsInitValue
    }, null, 8, ["columns", "get-data", "on-add", "on-delete", "on-edit", "loading"])
  ]))
}
}

})